import React from 'react';
import NavBar from "./NavBar";
import UserDropdown from "./UserDropdown";

export default function InternalUserNavbar({image_path, user, topbar_prop = ""}) {
    const components = [{component: <UserDropdown user={user}/>, dataCy: "UserDropdown"},]

    return <NavBar image_path={image_path} urls={[]} topbar_prop={topbar_prop} components={components}/>
}
